import HeaderNavMenu from './HeaderNavMenu';

// This class is only to initialize the header nav menus.
// It is a separate class so that we can initialize it on its own with different headers.
export default class HeaderNav {
  constructor(options) {
    this.header = options.header;

    this.navTier1 = this.header.querySelector('[data-header-nav-tier-1]');

    if (this.navTier1) {
      this.headerNavMenu = new HeaderNavMenu({
        navList: this.navTier1,
      });
    }
  }

  unload() {
    if (this.headerNavMenu) {
      this.headerNavMenu.unload();
    }
  }
}
